import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/aboutpage/banner/about-2.jpg")